import Table from "../../../../../../Components/Table"
import { pageSize } from "../../constants/allPageData"

// §BLOCK — the /recover/all disputes table. Wraps the shared antd Table with this
// page's layout decisions so AllPage stays about state; sorting and paging are handed
// back up through `onChange`, because the same handler also drives the refetch in
// hooks/useDisputesQuery.
const DisputesTable = ({
  loading,
  results,
  columns,
  count,
  page,
  onChange,
  onRowClick,
  EmptyComponent
}) => (
  <Table
    loading={loading}
    dataSource={Array.isArray(results) ? results : Array.from(results || [])}
    columns={columns}
    rowKey="id"
    rowHoverable
    // Constrain the body so it scrolls inside the table (sticky header +
    // pagination pinned at the bottom), instead of the whole page growing
    // past 50 rows. Mirrors the Alerts table. The constant is everything
    // above the body (page header + cards + divider + filters + thead)
    // plus the pagination row and the bottom padding.
    scroll={{ x: "max-content", y: "calc(100vh - 376px)" }}
    pagination={{ current: page, pageSize, total: count, showSizeChanger: false }}
    onChange={onChange}
    EmptyComponent={EmptyComponent}
    onRow={(record) => ({ onClick: () => onRowClick(record) })}
    className="disputes-table"
  />
)

export default DisputesTable
